import React, {Fragment} from "react";
import TextField from "canvas-core-react/lib/TextField";
import PropTypes from "prop-types";
import {useRunAfterUpdate} from "../../hooks";

const preventEvent = (event) => {
    event.preventDefault();
    event.nativeEvent.stopImmediatePropagation();
};

const EnhancedTextInput = ({
                               value,
                               id,
                               label,
                               secondaryLabel,
                               placeholder,
                               onChange,
                               presentation,
                               maxLength,
                               minLength,
                               error,
                               errorMsg,
                               colunmContainer = true,
                               className = "",
                               isPreventEvent = false,
                               tooltip,
                               disabled = false,
                           }) => {
    const runAfterUpdate = useRunAfterUpdate();
    const changed = (ev) => {
        const cursor = ev.target.selectionStart;
        const eventValue = ev.target.value;
        const newVal = presentation(ev.target.value);
        const oldVal = presentation(value);
        const input = ev.target;
        onChange(ev);
        runAfterUpdate((args) => {
            if (newVal !== null && oldVal !== null) {
                if (newVal === oldVal) {
                    if (eventValue.length > oldVal.length) {
                        return setCursor(input, cursor - 1);
                    }
                    if (eventValue.length === cursor) {
                        return setCursor(
                            input,
                            cursor + (oldVal.length - eventValue.length)
                        );
                    }
                    return setCursor(input, cursor);
                }
                if (newVal.length === oldVal.length) {
                    if (eventValue.length > oldVal.length) {
                        return setCursor(
                            input,
                            cursor + (eventValue.length - oldVal.length - 1)
                        );
                    } else {
                        return setCursor(
                            input,
                            cursor + (oldVal.length - eventValue.length)
                        );
                    }
                }
                if (newVal.length < oldVal.length) {
                    if (eventValue.length < newVal.length) {
                        return setCursor(
                            input,
                            cursor + (newVal.length - eventValue.length)
                        );
                    }
                    if (eventValue.length > newVal.length) {
                        return setCursor(
                            input,
                            cursor - (eventValue.length - newVal.length)
                        );
                    }
                    return setCursor(input, cursor);
                }
                if (newVal.length > oldVal.length) {
                    if (eventValue.length < newVal.length) {
                        return setCursor(
                            input,
                            cursor + (newVal.length - eventValue.length)
                        );
                    }
                    if (eventValue.length > newVal.length) {
                        return setCursor(
                            input,
                            cursor - (eventValue.length - newVal.length - 1)
                        );
                    }
                    return setCursor(input, cursor + (newVal.length - oldVal.length - 1));
                }
            }
        });
    };
    const setCursor = (input, cursor) => {
        input.selectionStart = cursor;
        input.selectionEnd = cursor;
    };

    const Input = (
        <TextField
            type="text"
            name={id}
            id={id}
            label={label}
            secondaryLabel={secondaryLabel}
            maxLength={maxLength}
            minLength={minLength}
            placeholder={placeholder}
            value={presentation(value)}
            onChange={changed}
            error={error ? {label: "Error", messages: [errorMsg]} : null}
            className={"input-control " + className}
            onCopy={isPreventEvent ? preventEvent : null}
            onPaste={isPreventEvent ? preventEvent : null}
            tooltip={tooltip}
            disabled={disabled}
        />
    );

    if (colunmContainer) {
        return <Fragment>{Input}</Fragment>;
    }
    return Input;
};

EnhancedTextInput.propTypes = {
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    error: PropTypes.bool,
    errorMsg: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    secondaryLabel: PropTypes.string,
    placeholder: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    presentation: PropTypes.func,
    offSet: PropTypes.bool,
};

EnhancedTextInput.defaultProps = {
    value: null,
    presentation: (t) => t,
    offSet: false,
};

export default EnhancedTextInput;
